<script lang="ts" setup>
const props = defineProps(['modelValue', 'placeholderText', 'menuWidth']);
const emit = defineEmits();
const keretaStore = useTrainStore();

const dropdownId = ref(`dropdown-${Math.random().toString(36).substring(7)}`);
const searchTerm = ref('');
const selectedStation = ref<any>(null);
const stationsList = ref<any>([]);
const filteredStations = ref<any>([]);
const localStorageStore = useLocalStorageStore();
const cariInput = ref();

const getStation = () => {
  try {
    const response: any = localStorageStore.getStations();
    stationsList.value = response?.filter((station: any) => station.status === 1);
    filteredStations.value = stationsList.value;
  } catch (error) {
    console.error(error);
  }
};

onMounted(() => {
  getStation();

  if (props.modelValue && Object.keys(props.modelValue).length > 0) {
    selectedStation.value = props.modelValue;
  } else {
    selectedStation.value = null; // Set to null if modelValue is empty
  }
});

watch(searchTerm, () => {
  if (!searchTerm.value) {
    filteredStations.value = stationsList.value;
  } else {
    filteredStations.value = stationsList.value.filter((station: { name: string; code: string; }) =>
      station.name.toLowerCase().includes(searchTerm.value.toLowerCase()) ||
      station.code.toLowerCase().includes(searchTerm.value.toLowerCase())
    );
  }
});

const focusSearch = () => {
  nextTick(() => {
    let element = cariInput.value;

    if (element) {
      setTimeout(() => {
        element.focus();
      }, 100); // Adjust the delay if necessary
    } else {
      console.error(`Element with ref cariInput not found`);
    }
  });
};

const selectStation = (station: any) => {
  searchTerm.value = '';
  selectedStation.value = station;
  emit('update:modelValue', station); // Emit event for v-model
};

watch(() => props.modelValue, (newValue) => {
  if (newValue && Object.keys(newValue).length > 0) {
    selectedStation.value = newValue; // Update selectedStation when modelValue changes
  } else {
    selectedStation.value = null; // Reset if modelValue is empty
  }
});
</script>

<template>
  <div class="dropdown input-group mb-3">
    <button
      class="form-select rounded text-start"
      type="button"
      :id="dropdownId"
      @click="focusSearch()"
      data-bs-toggle="dropdown"
      aria-expanded="false"
    >
      {{
        selectedStation
          ? `${selectedStation?.name} (${selectedStation?.code}) - ${selectedStation?.city}`
          : props.placeholderText
      }}
    </button>
    <ul
      class="dropdown-menu pt-0 w-100 full-width"
      :aria-labelledby="dropdownId"
      style="position: relative"
    >
      <div class="bg-white sticky-top py-1">
        <input
          type="text"
          class="form-control border border-1 rounded shadow-none m-2"
          style="max-width: calc(100% - 16px);top: 0"
          v-model="searchTerm"
          ref="cariInput"
          placeholder="Search..."
          autocomplete="off"
        />
      </div>
      <div class="scrollable-menu ms-2">
        <li v-for="station in filteredStations" style="cursor:pointer;" @click="selectStation(station)">
          <label>{{ station.name }}</label>
          <span class="badge bg-primary">{{ station.code }}</span>
          <div style="display: block">
            <small class="text-default"><em>{{ `${station.city}` }}</em></small>
          </div>
        </li>
      </div>
    </ul>
  </div>
</template>

<style scoped>
.dropdown button:hover {
  cursor: pointer;
}

.scrollable-menu {
  max-height: 200px;
  overflow: auto;
}

.scrollable-menu li {
  display: block;
  position: relative;
  padding: 8px;
  width: 100%;
}

.scrollable-menu li .badge {
  position: absolute;
  right: 8px;
  top: 33%;
  transform: translateY(-50%);
}

.scrollable-menu li:hover {
  background-color: #f8f9fa;
}
</style>